import { AspectRatio } from "../components/common/DropDowns/StaticDropdown";
import { AsyncProps } from "../utils/useImageUtils";

export type VideoEditingTools = "erase" | "remove_background" | "solid_background" | "increase_resolution";

export type VideoEditingSolidBgColor =
	"Transparent" | "Black" | "White" | "Gray" | "Red" | "Green" | "Blue" | "Yellow" | "Cyan" | "Magenta";

export type VideoEditingResolution = "2" | "4";

export type VideoEditingEraseConfig = {
	mask?: string;
};

export type VideoEditingRemoveBackgroundConfig = boolean;

export type VideoEditingSolidBackgroundConfig = {
	background_color?: VideoEditingSolidBgColor;
};

export type VideoEditingIncreaseResolutionConfig = {
	desired_increase?: VideoEditingResolution;
};

export type VideoEditingToolConfig = {
	erase?: VideoEditingEraseConfig;
	remove_background?: VideoEditingRemoveBackgroundConfig;
	solid_background?: VideoEditingSolidBackgroundConfig;
	increase_resolution?: VideoEditingIncreaseResolutionConfig;
};

export type VideoEditingConfigType = {
	video: string;
	tool?: VideoEditingTools;
	tool_config?: VideoEditingToolConfig;
};

export type TgVideoEditingConfigType = {
	model_id?: string;
	aspect_ratio: AspectRatio;
	fps: FPS;
	first_frame?: string;
	last_frame?: string;
	prompt: string;
};

export type VideoEditingTgConfig = {
	model_id: string;
	model_influence?: number;
	fast?: boolean;
};

export type VideoGenerationResponse = {
	url: string;
};

export type VideoEditingResponse = {
	video_url: string;
};

export const defaultTgVideoEditingConfig: TgVideoEditingConfigType = {
	model_id: "",
	aspect_ratio: "16:9",
	fps: 16,
	prompt: "",
};

export const defaultVideoEditingConfig: VideoEditingConfigType = {
	video: "",
};

export type FPS = 16 | 24 | 30;

export const VIDEO_EDITING_ASYNC_PROPS: Record<VideoEditingTools, AsyncProps> = {
	erase: {
		maxAttempts: 120,
		sleepSecs: 2,
	},
	increase_resolution: {
		maxAttempts: 120,
		sleepSecs: 2,
	},
	remove_background: {
		maxAttempts: 120,
		sleepSecs: 2,
	},
	solid_background: {
		maxAttempts: 120,
		sleepSecs: 2,
	},
};
